import { ToolOptionsProps } from '../ToolOptionsRenderer.types';
import { useToolOptionsRendererLogic } from '../ToolOptionsRenderer.logic';
import { ToolOptionsRendererProps } from '../../../BaseToolbar.types';
import { useCallback } from 'react';
import { LookupCodes } from 'src/constants/lookup.constants';
import { useColorOptions } from './useColorOptions';

export const useColorToolOptionsLogic = ({ options, ...otherProps }: ToolOptionsRendererProps<ToolOptionsProps>) => {
  const isPaperColor = !!options.find(item => item.productOptionCode === LookupCodes.PAPER_COLOR);
  const { colorOptions, setColorSelected, colorSelected } = useColorOptions({
    isPaperColor,
    options,
  });

  const customIsOptionSelectedValidation = useCallback(
    (option: ToolOptionsProps) => {
      return option.choiceDetails?.color === colorSelected;
    },
    [colorSelected],
  );

  const { scrollViewRef, getScrollViewElementTestId, onPressAndSelectToolOption, isOptionSelected } =
    useToolOptionsRendererLogic(
      { options: colorOptions, ...otherProps } as ToolOptionsRendererProps<ToolOptionsProps>,
      customIsOptionSelectedValidation,
    );

  return {
    scrollViewRef,
    getScrollViewElementTestId,
    colorOptions,
    onPressAndSelectToolOption: (option: ToolOptionsProps) => {
      setColorSelected(option.choiceDetails?.color);
      return onPressAndSelectToolOption(option);
    },
    isOptionSelected,
  };
};
